/* eslint-disable global-require */
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row, Image, Container, Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import { getCookies, getPermissions } from "../../hooks/useCookies";
import { TableContext } from "../../contexts/tableContext";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import styles from "./viewPopup.module.scss";
import TextInput from "../../components/TextField/TextField";
import SelectBox from "../../components/SelectBox/SelectBox";
import { DateFormatter } from "../../utilityFunctions/utilsFunctions";
import envValues from "../../enviornment";
import { Entry } from "../../redux/entrySlice";
import { useDispatch } from "react-redux";
import CustomTable from "../../components/CustomTable/CustomTable";
import { REACT_APP_API_FETCH_MENUS } from "../../redux/apiConstants";
import RefreshPosItemsModal from "../../components/RefreshPosItemsModal/RefreshPosItemsModal";
import { Badge } from "react-bootstrap";
import Loader from '../../components/Loader/Loader';
import VendorDocumentsSection from "./VendorDocumentsSection";
import OrderAheadEnabledBadge from "./OrderAheadEnabledBadge";
import CafeNameAvatar from "./CafeNameAvatar";

function SuspendCafeModal({ show, handleClose, cafeId }) {
  const [submiting, setSubmitting] = useState(false);

  const periods = [
    {
      value: "1week",
      label: "1 Week",
    },
    {
      value: "1month",
      label: "1 Month",
    },
    {
      value: "6month",
      label: "6 Month",
    },
  ];

  console.log("cafe Id ", cafeId);

  const { errormsgStyle, setSuspend } = useContext(TableContext);
  const [error, setError] = useState(null);

  const dispatch = useDispatch();

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  function onSubmitdata(data) {
    console.log("datat", data);

    setSubmitting(true);
    const apiData = {
      suspendReason: data.reason,
      suspendPeriod: data.period,
    };
    data.actionUrl = `cafe/suspend-cafe/${cafeId}`;
    data.actionMethod = "post";
    data.apiData = apiData;
    dispatch(Entry(data)).then((resp) => {
      console.log("responsee-----", resp);
      setSubmitting(false);
      if (resp.payload.code === 200) {
        handleClose();
        toast.success("Cafe suspended successfully");
        setSuspend(true);
      } else if (resp.payload.code === 401 || resp.payload.code === 400) {
        setError(resp.payload.message);
        toast.success("Cafe suspended successfully");
      } else {
        setError(resp.payload.message);
      }
    });
  }

  const handleSuspend = () => {
    // Validate reason and period if needed
    // suspendCafe(reason, period);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Suspend Cafe</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmitdata)}>
          <div>
            <TextInput
              className={styles.inputbox}
              classNamedark={styles.inputbox1}
              labelstyle={styles.formlabel}
              label="Reason"
              fieldName="reason"
              placeHolder="Enter reason"
              register={register}
              errors={errors}
              isRequired
              mandatory
            />
          </div>
          <div>
            <SelectBox
              className={styles.inputbox}
              classNamedark={styles.inputbox1}
              name="period"
              label="Period"
              labelstyle={styles.formlabel}
              control={control}
              register={register}
              values={periods}
              errors={errors}
              placeholder="Select Period"
              mandatory
              isRequired
            />
          </div>
          <Button color="primary" type="submit">
            Suspend
          </Button>{" "}
          <Button color="secondary" onClick={handleClose}>
            Cancel
          </Button>
          {error && (
            <h6 className={styles[errormsgStyle]} style={{ float: "right" }}>
              {error}
            </h6>
          )}
        </form>
      </Modal.Body>
    </Modal>
  );
}

const ViewCafePopup = React.memo(({ cafeId, handleClose }) => {
  const { dashboardStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);
  const { formthemeStyle, bodyheader, viewformStyle } =
    useContext(TableContext);
  const { suspend, setSuspend } = useContext(TableContext);
  const dispatch = useDispatch();
  const params = useParams(); 
  // let payoutId;
  const token = `Bearer ${getCookies("Token")}`;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const dateFormat = getCookies("dateFormat");
  const [canDelete, setCanDelete] = useState(true);
  const [cafeList, setCafesList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showRefreshModal, setShowRefreshModal] = useState(false);
  const [canEditVendorApplication, setCanEditVendorApplication] = useState(false);
  const [cafeImageLoadFailed, setCafeImageLoadFailed] = useState(false);

  const handleCloseRefreshModal = () => {
    setShowRefreshModal(false);
    getUserDetails();
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  let statusCode;
  const getUserDetails = async () => {
    setLoading(true);
    axios
      .get(`${envValues.REACT_APP_API_ENDPOINT}/cafe/${cafeId}`, {
        method: "GET",
        headers: { Authorization: token },
      })
      .then((resp) => {
        statusCode = resp.status;
        return resp.data;
      })
      .then((res) => {
        if (statusCode === 200) {
          console.log("res.data.cafe", res.data.cafe);
          console.log("Document Fields:", {
            healthPermitUrl: res.data.cafe?.healthPermitUrl,
            insuranceUrl: res.data.cafe?.insuranceUrl,
            insuranceSkipped: res.data.cafe?.insuranceSkipped,
            healthPermitReviewStatus: res.data.cafe?.healthPermitReviewStatus,
            insuranceReviewStatus: res.data.cafe?.insuranceReviewStatus,
          });
          setDetails(res.data.cafe);
          setCafeImageLoadFailed(false);
          setSuspend(res.data.cafe?.isSuspended);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    //   cafeId = params.cafeId;
    getUserDetails();
    setDashboardHeader("Cafe Details");
    
    // Fetch vendor application edit permission
    const permissions = getPermissions();
    const vendorApplicationSection = "vendorapplications";
    permissions.forEach((val) => {
      if (val.section.replace(/\s+/g, "").toLowerCase() === vendorApplicationSection) {
        setCanEditVendorApplication(val.edit ? val.edit : false);
      }
    });
  }, []);

  const handleDelete = (id) => {
    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: "Are you sure you want to delete?",
      buttons: canDelete
        ? [
            {
              label: "Yes",
              onClick: () => {
                const actionData = {};
                actionData.actionUrl = `cafe/${id}`;
                actionData.actionMethod = "delete";
                dispatch(Entry(actionData)).then(() => {
                  navigate(-1);
                  toast.success("Cafe deleted successfully");
                });
              },
            },
            {
              label: "No",
              // onClick: () => alert("Click No")
            },
          ]
        : [
            {
              label: "Ok",
              // onClick: () => alert("Click No")
            },
          ],
    });
  };

  const removeSuspension = (id) => {
    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: "Are you sure you want to remove suspension?",
      buttons: canDelete
        ? [
            {
              label: "Yes",
              onClick: () => {
                const actionData = {};
                actionData.actionUrl = `cafe/un-suspend-cafe/${id}`;
                actionData.actionMethod = "post";
                dispatch(Entry(actionData)).then(() => {
                  // navigate(-1);
                  setSuspend(false);
                  toast.success("Cafe unsuspended successfully");
                });
              },
            },
            {
              label: "No",
              // onClick: () => alert("Click No")
            },
          ]
        : [
            {
              label: "Ok",
              // onClick: () => alert("Click No")
            },
          ],
    });
  };

  const goToMenu = async () => {
    console.log("params.cafeId", cafeId);
    navigate(`/menu/${cafeId}`);
  };

  const handleReject = async () => {
    confirmAlert({
      title: "Reject Cafe Application",
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>Reject Cafe Application</h1>
            <p>Please provide detailed feedback for the vendor:</p>
            <textarea
              id="rejectionNotesInput"
              className="form-control"
              rows={4}
              placeholder="Please provide detailed feedback for the vendor..."
              style={{ width: "100%", marginBottom: "15px" }}
            />
            <div className="react-confirm-alert-button-group">
              <button
                className="btn btn-danger"
                onClick={() => {
                  const notes = document.getElementById("rejectionNotesInput").value;
                  if (!notes || notes.trim().length < 10) {
                    toast.warning("Please provide at least 10 characters of feedback");
                    return;
                  }
                  
                  const actionData = {
                    actionUrl: `cafe/reject-cafe/${cafeId}`,
                    actionMethod: "post",
                    apiData: { notes },
                  };
                  
                  dispatch(Entry(actionData))
                    .then(() => {
                      handleClose();
                      toast.success("Cafe request rejected successfully");
                      onClose();
                    })
                    .catch((err) => {
                      toast.error("Error rejecting cafe request");
                      console.error("Error: ", err);
                    });
                }}
              >
                Confirm Rejection
              </button>
              <button className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleApprove = async (id) => {
    // Check if application is rejected
    if (details?.applicationStatus && details.applicationStatus === "Rejected") {
      confirmAlert({
        title: "Application Rejected",
        message: "This café's application has been rejected. The vendor must resubmit their application with the required updates before it can be approved.",
        buttons: [
          {
            label: "View Application Details",
            onClick: () => {
              navigate(`/vendorapplications/viewdetails/${id}`);
            },
          },
          {
            label: "Close",
          },
        ],
      });
      return;
    }

    // If this cafe has an applicationStatus, show dialog to redirect to vendor applications
    if (details?.applicationStatus && (details.applicationStatus === "Submitted" || details.applicationStatus === "In Review")) {
      confirmAlert({
        title: "Review Application Documents",
        message: "Please review and approve all application documents first from the Vendor Applications section.",
        buttons: [
          {
            label: "Go to Application Details",
            onClick: () => {
              navigate(`/vendorapplications/viewdetails/${id}`);
            },
          },
          {
            label: "Cancel",
          },
        ],
      });
      return;
    }

    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: "Are you sure you want to approve the cafe request?",
      buttons: canDelete
        ? [
            {
              label: "Yes",
              onClick: () => {
                const actionData = {};
                actionData.actionUrl = `cafe/approve-cafe/${id}`;
                actionData.actionMethod = "post";
                dispatch(Entry(actionData)).then(() => {
                  handleClose();
                  setSuspend(false);
                  toast.success("Cafe request approved successfully");
                });
              },
            },
            {
              label: "No",
              // onClick: () => alert("Click No")
            },
          ]
        : [
            {
              label: "Ok",
              // onClick: () => alert("Click No")
            },
          ],
    });
  };

  const handleReviewDocument = (cafeId, documentType) => {
    confirmAlert({
      title: "Confirm Review",
      message: `Mark this ${documentType === 'healthPermit' ? 'Health Permit' : 'Insurance'} document as reviewed?`,
      buttons: [
        {
          label: "Yes, Mark as Reviewed",
          onClick: () => {
            const data = {
              actionUrl: `cafe/${cafeId}/review-document`,
              actionMethod: "post",
              apiData: { documentType },
            };
            dispatch(Entry(data)).then((resp) => {
              if (resp.payload.code === 200) {
                toast.success("Document marked as reviewed!");
                getUserDetails(); // Refresh cafe details
              } else {
                toast.error(resp.payload.message || "Failed to review document");
              }
            });
          },
        },
        {
          label: "Cancel",
          onClick: () => {},
        },
      ],
    });
  };
  return (
    <div className={styles.popupbox}>
      <div className={styles[formthemeStyle]} id={styles.box}>
        <span
          className={styles.closeicon}
          role="button"
          tabIndex={0}
          onClick={handleClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </span>
        {loading ? (
          <Loader centered />
        ) : (
          <Container fluid>
            {/* <FontAwesomeIcon
                    icon={faArrowLeft}
                    value="Back"
                    onClick={() => {
                      navigate(-1);
                    }}
                    className={styles.arrowback}
                  /> */}
            <Row>
              <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                <h5 className={`${styles[bodyheader]} mb-0`} id={styles.addheading}>
                  Cafe Details
                </h5>
                <OrderAheadEnabledBadge cafe={details} />
              </div>
              <Col lg={8}>
                <div className={styles.profilepicdiv}>
                  <CafeNameAvatar
                    name={details?.name}
                    src={details?.image}
                    size={100}
                    imageLoadFailed={cafeImageLoadFailed}
                    onImageError={() => setCafeImageLoadFailed(true)}
                    ariaLabel={`${details?.name || "Cafe"} avatar`}
                  />
                </div>
              </Col>
              {/* <Col lg={4}>
                      <div className={styles.profilepicdiv}>
                        <Button
                          onClick={() => {
                            goToMenu();
                          }}
                        >
                          Go to menu page
                        </Button>
                      </div>
                    </Col> */}
            </Row>
            <Row className="mt-3">
              <Col lg={12} md={12} sm={12}>
                <div className={styles.detaildiv}>
                  <Row>
                    <Col lg={4}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Name</span>
                        <p className={styles.empname}>{details.name}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Location (For GPS)</span>
                        <p className={styles.empname}>
                          {details.location_name ?? "NA"}
                        </p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Address</span>
                        <p className={styles.empname}>
                          {details?.address ?? "NA"}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Working Hours (24-hour format)</span>
                        {details?.timings && details.timings.length > 0 ? (
                          details.timings.map((timing, index) => (
                            <div key={index} className={styles.timingContainer} style={{ marginBottom: "12px" }}>
                              <p className={styles.dayOfWeek} style={{ fontWeight: "600", marginBottom: "6px" }}>
                                {timing.dayOfWeek}:
                              </p>
                              {timing.periods && timing.periods.length > 0 ? (
                                timing.periods.map((period, periodIndex) => (
                                  <div key={periodIndex} style={{ marginLeft: "12px", marginBottom: "4px" }}>
                                    {period.startLocalTime === "" || period.endLocalTime === "" ? (
                                      <p style={{ fontSize: "0.9rem", color: "#888" }}>
                                        Period {periodIndex + 1}: NA
                                      </p>
                                    ) : (
                                      <p style={{ fontSize: "0.9rem" }}>
                                        <span style={{ color: "#666" }}>Period {periodIndex + 1}: </span>
                                        <span className={styles.time}>
                                          {period.startLocalTime}
                                        </span>
                                        <span className={styles.time}> - </span>
                                        <span className={styles.time}>
                                          {period.endLocalTime}
                                        </span>
                                        {period.isNextDay && (
                                          <span style={{ fontSize: "0.75rem", color: "#ff6b6b", marginLeft: "6px" }}>
                                            (next day)
                                          </span>
                                        )}
                                      </p>
                                    )}
                                  </div>
                                ))
                              ) : (
                                // Fallback for old format with startTime/endTime
                                timing.startTime && timing.endTime ? (
                                  <div style={{ marginLeft: "12px" }}>
                                    <p style={{ fontSize: "0.9rem" }}>
                                      <span className={styles.time}>
                                        {timing.startTime}
                                      </span>
                                      <span className={styles.time}> - </span>
                                      <span className={styles.time}>
                                        {timing.endTime}
                                      </span>
                                    </p>
                                  </div>
                                ) : (
                                  <p style={{ fontSize: "0.9rem", color: "#888", marginLeft: "12px" }}>NA</p>
                                )
                              )}
                            </div>
                          ))
                        ) : (
                          <p className={styles.empname}>NA</p>
                        )}
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Name of Vendor</span>
                        <p className={styles.empname}>
                          {details?.vendor?.name ?? "NA"}
                        </p>
                      </div>
                    </Col>

                    <Col lg={4}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Email</span>
                        <p className={styles.empname}>
                          {details?.vendor?.email ?? "NA"}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>
                          Total Orders Completed
                        </span>
                        <p className={styles.empname}>
                          {details.totalOrders ?? 0}
                        </p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Social Media Links</span>
                        <p className={styles.empname}>
                          {details.facebook ? (
                            <a
                              href={details.facebook}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Facebook
                            </a>
                          ) : null}
                          {details.facebook && details.instagram ? " / " : null}
                          {details.instagram ? (
                            <a
                              href={details.instagram}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Instagram
                            </a>
                          ) : null}
                          {!details.facebook && !details.instagram
                            ? "NA"
                            : null}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <VendorDocumentsSection
                    cafe={details}
                    dateFormat={dateFormat}
                    canReviewDocuments={canEditVendorApplication}
                    onReviewDocument={(documentType) =>
                      handleReviewDocument(details._id, documentType)
                    }
                  />

                  {/* <Row></Row> */}
                  <Row>
                    <Col lg={2}>
                      <div
                        // className={styles[viewformStyle]}
                        id={styles.empdiv}
                      >
                        <Button
                          className={`${styles.title} btn-success`}
                          onClick={() => {
                            handleApprove(details?._id);
                          }}
                        >
                          Approve Cafe
                        </Button>
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div
                        // className={styles[viewformStyle]}
                        id={styles.empdiv}
                      >
                        <Button
                          className={`${styles.title} btn-danger`}
                          onClick={() => handleReject()}
                        >
                          Reject Cafe
                        </Button>
                      </div>
                    </Col>
                    {details?.posConnected && details?.posSoftware === "square" && (
                      <Col lg={2}>
                        <div id={styles.empdiv}>
                          <Button
                            className={`${styles.title} btn-info`}
                            onClick={() => setShowRefreshModal(true)}
                          >
                            Sync from Square
                          </Button>
                        </div>
                      </Col>
                    )}
                    <Col lg={2}>
                      <div
                        // className={styles[viewformStyle]}
                        id={styles.empdiv}
                      >
                        {suspend ? (
                          <Button
                            className={styles.title}
                            onClick={() => removeSuspension(details?._id)}
                          >
                            Remove Suspension
                          </Button>
                        ) : (
                          <Button
                            className={`${styles.title} btn-secondary`}
                            onClick={() => setShowModal(true)}
                          >
                            Suspend Cafe
                          </Button>
                        )}

                        <SuspendCafeModal
                          show={showModal}
                          handleClose={handleCloseModal}
                          cafeId={details?._id}
                        />

                        <RefreshPosItemsModal
                          show={showRefreshModal}
                          handleClose={handleCloseRefreshModal}
                          cafeId={details?._id}
                          cafeName={details?.name}
                        />
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div
                        // className={styles[viewformStyle]}
                        id={styles.empdiv}
                      >
                        <Button
                          className={`${styles.title} btn-danger`}
                          onClick={() => {
                            handleDelete(details?._id);
                          }}
                        >
                          Delete Cafe
                        </Button>
                      </div>
                    </Col>
                    {details?.cafeStatus === "Pending" && <Row></Row>}
                    {!details?.isClaimed && !details.isClaimed && (
                      // <Row>
                      <Col lg={4}>
                        <div
                          // className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <Button
                            className={`${styles.title} btn-primary`}
                            disabled={details?.claimRequestsCount === 0}
                            onClick={() =>
                              navigate(`/claim-requests/${params.cafeId}`)
                            }
                          >
                            Claim Requests:{" "}
                            {/* {details?.claimRequestsCount || 0} */}
                          </Button>
                        </div>
                      </Col>
                      // </Row>
                    )}
                  </Row>

                </div>
              </Col>
            </Row>
            {cafeList.length > 0 && (
              <Row>
                <Col lg={12}>
                  <h5>Cafes</h5>
                  <ol>
                    {cafeList?.map((cafe, index) => (
                      <li key={cafe.id}>
                        {/* <span>{index + 1}. </span> */}
                        <span>{cafe.name}</span>
                        <span> {cafe?.location_name}</span>
                      </li>
                    ))}
                  </ol>
                </Col>
              </Row>
            )}
          </Container>
        )}
        <Row>
          <Col lg={12}>
            <CustomTable
              urlParam={`${REACT_APP_API_FETCH_MENUS}/${cafeId}?`}
              viewPopUp={true}
              paramId={cafeId}
              section="Menus"
              toggleButton={{ show: true, field: "active" }}
              deleteCondition={{
                checkCondition: false,
                apiUrl: "www.google.com",
              }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
});

export default ViewCafePopup;
